import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Input, Output, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BathroomRangeDto } from 'src/app/models/configurators-2d/common-bathroom-dtos';
import { BathroomCompositionDto } from 'src/app/models/configurators-2d/mobile/bathroom/bathroom-composition-dtos';
import { BathroomService } from 'src/app/services/configurators-2d/applications/bathroom.service';
import { BathroomConfigurationService } from 'src/app/services/configurators-2d/mobile/bathroom/bathroom-configuration.service';
import { CompositionFilters } from 'src/app/models/configurators-2d/mobile/bathroom/bathroom-composition-dtos';

@Component({
  selector: 'ng-casto-composition',
  templateUrl: './composition.component.html',
  styleUrl: './composition.component.scss',
})
export class CompositionComponent implements OnInit {
  @ViewChild('rangeImage') rangeImageRef: ElementRef;
  @Input() embedded: boolean = false;
  @Input() layoutMode: 'mobile' | 'desktop' = 'mobile';
  @Input() rangeIdInput: string | null = null;
  @Output() compositionSelected = new EventEmitter<BathroomCompositionDto>();
  @Output() backRequested = new EventEmitter<void>();

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly bathroomService = inject(BathroomService);
  private readonly configurationService = inject(BathroomConfigurationService);

  rangeId: string | null = null;
  range: BathroomRangeDto;
  compositions: BathroomCompositionDto[] = [];
  isLoading: boolean = false;
  error: string | null = null;
  imageScrollPosition: number = 0;

  /** Contrôle l'affichage de la modale de filtres */
  isFiltersModalOpen: boolean = false;

  /** Filtres appliqués (null si aucun filtre) */
  appliedFilters: CompositionFilters | null = null;

  async ngOnInit(): Promise<void> {
    // Récupérer le rangeId depuis les paramètres de route
    this.rangeId = this.rangeIdInput ?? this.route.snapshot.paramMap.get('rangeId');

    if (!this.rangeId) {
      this.error = 'Aucune gamme sélectionnée';
      return;
    }

    // Ouvrir la modal des filtres uniquement la première fois
    if (!this.embedded && !this.configurationService.hasShownFiltersModal) {
      this.isFiltersModalOpen = true;
      this.configurationService.hasShownFiltersModal = true;
    }

    await this.loadCompositions();
  }

  private async loadCompositions(): Promise<void> {
    if (!this.rangeId) return;

    this.isLoading = true;
    this.error = null;

    try {
      // Charger les compositions pour cette gamme avec les filtres éventuels
      this.compositions = await this.bathroomService.getCompositionsByRangeId(this.rangeId, this.appliedFilters);
      this.compositions = this.compositions.toSorted((a, b) => a.name.localeCompare(b.name, 'fr', { numeric: true }));

      // Charger aussi les infos de la gamme pour afficher son nom et image
      await this.loadRangeInfo();
    } catch (error) {
      this.error = 'Erreur lors du chargement des compositions';
      console.error('Erreur lors du chargement des compositions', error);
    } finally {
      this.isLoading = false;
    }
  }

  private async loadRangeInfo(): Promise<void> {
    try {
      const allRanges = await this.bathroomService.getAllRange();
      this.range = allRanges.find(r => r.id === this.rangeId);
    } catch (error) { }
  }

  onCompositionClick(composition: BathroomCompositionDto): void {
    console.log('Composition sélectionnée:', composition);

    if (this.embedded) {
      this.compositionSelected.emit(composition);
      return;
    }

    // Navigation vers la page de configuration
    this.router.navigate(['/salle-de-bain-mobile/configuration', composition.id]);
  }

  goBack(): void {
    if (this.embedded) {
      this.backRequested.emit();
      return;
    }

    this.router.navigateByUrl('/');
  }

  // Gestion de la modale de filtres

  async onFiltersApplied(filters: CompositionFilters): Promise<void> {
    this.appliedFilters = filters;
    this.configurationService.maxFurnitureWidth = filters.maxFurnitureWidth;
    this.isFiltersModalOpen = false;
    await this.loadCompositions();
  }

  onFiltersSkipped(): void {
    this.appliedFilters = null;
    this.configurationService.maxFurnitureWidth = null;
    this.isFiltersModalOpen = false;
  }

  onFiltersModalClosed(): void {
    this.isFiltersModalOpen = false;
  }

  openFiltersModal(): void {
    this.isFiltersModalOpen = true;
  }
}
